module.exports = __webpack_public_path__ + "static/media/sriracha-egger-hero-desktop.ef3b7573.jpg";